module.exports = __webpack_public_path__ + "files/2e81111e1272ec3006a7b9795e0c02ce.png";